export const screenScrollTo = (x = 0, y = 0) => {
  if (!window.location.hash)
    window.scrollTo({
      top: y,
      left: x,
      behavior: "smooth",
    });
};
